import { Logo } from '../components/commons/logo';

export default function LogoutDone() {
    return (
        <Logo text_key='logout_done' />
    )
}

